import { render } from "./SendTextInput.vue?vue&type=template&id=108e34a3&scoped=true"
import script from "./SendTextInput.vue?vue&type=script&lang=js"
export * from "./SendTextInput.vue?vue&type=script&lang=js"

import "./SendTextInput.vue?vue&type=style&index=0&id=108e34a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108e34a3"]])

export default __exports__